module.exports = __webpack_public_path__ + "img/yt_icon_mono_dark.6c71c494.png";